(function () {
  'use strict';

  var PRODUCT_HANDLES = {
    '9104815128796': 'multivitamins-upsell',
    '9104934961372': 'probiotics-upsell',
    '8762413482204': null,
    '7208824176814': 'kittymat',
    '7697927307484': 'stainless-steel-replacement-filters',
    '8075547574492': 'the-kittyball',
    '8369555243228': 'wireless-filters',
    '8947403751644': 'stainless-steel-replacement-filters2',
    '7196329607342': 'free-pumps-for-life'
  };

  var RULES = [
    {
      trigger: ['9090910322908','9098321625308','9098286727388','9098322149596','9115325399260'],
      show:    ['9104815128796']
    },
    {
      trigger: ['9099685134556','9099685036252','9099685003484'],
      show:    ['9104934961372']
    },
    {
      trigger: ['7687835353308','8056571691228','8071187366108','8841313419484','8914509758684','8764283158748','8962407465180'],
      show:    ['8762413482204','7208824176814','7697927307484']
    },
    {
      trigger: ['8369671045340','8815603450076','8914738249948','8962452947164'],
      show:    ['8075547574492','7208824176814','8369555243228']
    },
    {
      trigger: ['8932719460572','8932735647964','8965997920476','8965998870748','8965998411996','8965994152156'],
      show:    ['8947403751644']
    },
    {
      trigger: ['9047184146652'],
      show:    ['7208824176814','7196329607342']
    }
  ];

  var DEFAULT_SHOW = ['7196329607342'];

  var _renderedKey = null;
  var _productCache = {};
  var _pageRuleCache = {};
  var _H = { 'X-Requested-With': 'XMLHttpRequest' };

  var META_RULES = [];

  function readJsonScript(id) {
    try {
      return JSON.parse(document.getElementById(id)?.textContent || '{}');
    } catch (_) {
      return {};
    }
  }

  function readInitialMetafieldRules() {
    var cdConfig = readJsonScript('cd-config');
    var rules = [];

    if (Array.isArray(cdConfig.drawerUpsellRules)) {
      rules = rules.concat(cdConfig.drawerUpsellRules);
    }

    if (Array.isArray(cdConfig.upsellRules)) {
      rules = rules.concat(cdConfig.upsellRules);
    }

    document.querySelectorAll('script[type="application/json"]').forEach(function (script) {
      try {
        var json = JSON.parse(script.textContent || '{}');

        if (json.drawerUpsellRule) {
          rules.push(json.drawerUpsellRule);
        }

        if (Array.isArray(json.drawerUpsellRules)) {
          rules = rules.concat(json.drawerUpsellRules);
        }
      } catch (_) {}
    });

    rules.forEach(registerRule);
  }

  function normalizeIds(ids) {
    return Array.from(new Set((ids || []).map(function (id) {
      return String(id || '').trim();
    }).filter(Boolean)));
  }

  function normalizeUpsellCandidate(raw) {
    if (!raw) return null;

    if (typeof raw === 'string' || typeof raw === 'number') {
      var productId = String(raw);
      return {
        productId: productId,
        handle: PRODUCT_HANDLES[productId] || ''
      };
    }

    var productId = String(raw.productId || raw.product_id || raw.id || '').trim();
    var variantId = String(raw.variantId || raw.variant_id || '').trim();
    var handle = String(raw.handle || raw.productHandle || raw.product_handle || PRODUCT_HANDLES[productId] || '').trim();

    if (!productId && !variantId && !handle) return null;

    return {
      productId: productId,
      variantId: variantId,
      handle: handle,
      title: raw.title || raw.product_title || '',
      url: raw.url || (handle ? '/products/' + handle : ''),
      image: raw.image || raw.imageUrl || raw.image_url || '',
      price: Number(raw.price || raw.priceCents || raw.price_cents || 0),
      compareAtPrice: Number(raw.compareAtPrice || raw.compare_at_price || raw.comparePrice || raw.compare_price || 0)
    };
  }

  function normalizeRule(rule) {
    if (!rule) return null;

    var triggerIds = normalizeIds(rule.triggerIds || rule.trigger_ids || rule.trigger || []);
    var rawUpsells = rule.upsells || rule.drawerUpsells || rule.drawer_upsells || rule.products || rule.show || [];
    var upsells = (rawUpsells || []).map(normalizeUpsellCandidate).filter(Boolean);

    if (!triggerIds.length || !upsells.length) return null;

    return {
      triggerIds: triggerIds,
      upsells: upsells,
      source: rule.source || rule._source || 'metafield'
    };
  }

  function sameTriggerSet(a, b) {
    return normalizeIds(a).sort().join(',') === normalizeIds(b).sort().join(',');
  }

  function registerRule(rule) {
    var normalized = normalizeRule(rule);
    if (!normalized) return false;

    for (var i = META_RULES.length - 1; i >= 0; i--) {
      if (sameTriggerSet(META_RULES[i].triggerIds, normalized.triggerIds)) {
        META_RULES.splice(i, 1);
      }
    }

    META_RULES.push(normalized);
    _renderedKey = null;

    return true;
  }

  function isPP(item) {
    var drawer = document.getElementById('CartDrawer');
    var ppHandle = drawer ? String(drawer.dataset.ppHandle || '').toLowerCase() : 'package-protection';
    var known = ['package-protection', 'free-returns-package-protection-1', ppHandle];

    return (
      known.indexOf(String(item.handle || '').toLowerCase()) !== -1 ||
      String(item.product_type || '').toLowerCase().indexOf('package_protection') !== -1 ||
      String(item.vendor || '').toLowerCase() === 're:do'
    );
  }

  function isGift(item) {
    if (window.GiftSync && typeof window.GiftSync.isGift === 'function') {
      return window.GiftSync.isGift(item);
    }

    return item && item.properties && item.properties._gift === 'true';
  }

  function isVisibleCartItem(item) {
    return item && !isPP(item) && !isGift(item);
  }

  function getActiveCurrency() {
    var currency = '';

    if (window.Shopify && window.Shopify.currency) {
      currency = window.Shopify.currency.active || window.Shopify.currency.current || '';
    }

    if (!currency && window.Shopify && window.Shopify.checkout) {
      currency = window.Shopify.checkout.currency || '';
    }

    return String(currency || 'USD').toUpperCase();
  }

  function money(cents) {
    var v = Number(cents || 0) / 100;
    var currency = getActiveCurrency();

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(v);
    } catch (_) {
      return '$' + v.toFixed(2);
    }
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function getCartIds(cart) {
    var productIds = {};
    var variantIds = {};

    (cart.items || []).forEach(function (item) {
      if (!isVisibleCartItem(item)) return;

      productIds[String(item.product_id)] = true;
      variantIds[String(item.variant_id)] = true;
    });

    return {
      productIds: productIds,
      variantIds: variantIds
    };
  }

  function ruleMatchesCartItem(rule, item) {
    if (!rule || !item) return false;

    var productId = String(item.product_id || '');
    var variantId = String(item.variant_id || '');

    return rule.triggerIds.indexOf(productId) !== -1 || rule.triggerIds.indexOf(variantId) !== -1;
  }

  function findLocalMetafieldCandidates(cart) {
    var items = (cart.items || []).filter(isVisibleCartItem);

    for (var i = 0; i < items.length; i++) {
      for (var r = 0; r < META_RULES.length; r++) {
        if (ruleMatchesCartItem(META_RULES[r], items[i])) {
          return META_RULES[r].upsells;
        }
      }
    }

    return null;
  }

  function resolveHardcodedShowIds(cart) {
    var cartIds = getCartIds(cart).productIds;

    for (var i = 0; i < RULES.length; i++) {
      var rule = RULES[i];

      for (var j = 0; j < rule.trigger.length; j++) {
        if (cartIds[rule.trigger[j]]) return rule.show;
      }
    }

    return DEFAULT_SHOW;
  }

  function hardcodedCandidates(ids) {
    return (ids || []).map(function (id) {
      return normalizeUpsellCandidate({
        productId: id,
        handle: PRODUCT_HANDLES[id] || ''
      });
    }).filter(Boolean);
  }

  async function fetchProductByHandle(handle) {
    if (!handle) return null;

    if (_productCache[handle]) {
      return _productCache[handle];
    }

    try {
      var r = await fetch('/products/' + handle + '.js', { headers: _H });

      if (!r.ok) {
        _productCache[handle] = null;
        return null;
      }

      var p = await r.json();
      _productCache[handle] = p;

      return p;
    } catch (_) {
      _productCache[handle] = null;
      return null;
    }
  }

  async function fetchMetafieldRuleFromProductPage(item) {
    var handle = String(item.handle || '').trim();

    if (!handle) return null;

    if (handle in _pageRuleCache) {
      return _pageRuleCache[handle];
    }

    try {
      var r = await fetch('/products/' + handle, { headers: _H });

      if (!r.ok) {
        _pageRuleCache[handle] = null;
        return null;
      }

      var html = await r.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var foundRule = null;

      doc.querySelectorAll('script[type="application/json"]').forEach(function (script) {
        if (foundRule) return;

        try {
          var json = JSON.parse(script.textContent || '{}');
          var candidateRule = json.drawerUpsellRule || null;

          if (!candidateRule && Array.isArray(json.drawerUpsellRules) && json.drawerUpsellRules.length) {
            candidateRule = json.drawerUpsellRules.find(function (rule) {
              var triggerIds = normalizeIds(rule.triggerIds || rule.trigger_ids || rule.trigger || []);
              return triggerIds.indexOf(String(item.product_id)) !== -1 || triggerIds.indexOf(String(item.variant_id)) !== -1;
            }) || json.drawerUpsellRules[0];
          }

          var normalized = normalizeRule(candidateRule);

          if (normalized) {
            foundRule = normalized;
          }
        } catch (_) {}
      });

      _pageRuleCache[handle] = foundRule;
      if (foundRule) registerRule(foundRule);

      return foundRule;
    } catch (_) {
      _pageRuleCache[handle] = null;
      return null;
    }
  }

  async function resolveMetafieldCandidates(cart) {
    var localCandidates = findLocalMetafieldCandidates(cart);

    if (localCandidates && localCandidates.length) {
      return localCandidates;
    }

    var items = (cart.items || []).filter(isVisibleCartItem);

    for (var i = 0; i < items.length; i++) {
      var rule = await fetchMetafieldRuleFromProductPage(items[i]);

      if (rule && ruleMatchesCartItem(rule, items[i])) {
        return rule.upsells;
      }
    }

    return null;
  }

  async function resolveUpsellCandidates(cart) {
    var metafieldCandidates = await resolveMetafieldCandidates(cart);

    if (metafieldCandidates && metafieldCandidates.length) {
      return metafieldCandidates;
    }

    return hardcodedCandidates(resolveHardcodedShowIds(cart));
  }

  function pickEligibleCandidate(candidates, cart) {
    var ids = getCartIds(cart);

    for (var i = 0; i < (candidates || []).length; i++) {
      var candidate = candidates[i];
      if (!candidate) continue;

      var productId = String(candidate.productId || '');
      var variantId = String(candidate.variantId || '');

      if (productId && ids.productIds[productId]) continue;
      if (variantId && ids.variantIds[variantId]) continue;
      if (!candidate.handle && productId && PRODUCT_HANDLES[productId]) candidate.handle = PRODUCT_HANDLES[productId];

      if (candidate.variantId || candidate.handle || candidate.title) {
        return candidate;
      }
    }

    return null;
  }

  async function fetchCandidateProduct(candidate) {
    if (!candidate) return null;
    if (!candidate.handle) return null;

    return fetchProductByHandle(candidate.handle);
  }

  function getProductImage(product) {
    if (!product) return '';

    if (product.featured_image) {
      return typeof product.featured_image === 'string'
        ? product.featured_image
        : (product.featured_image.src || '');
    }

    if (product.images && product.images[0]) {
      return product.images[0].src || product.images[0] || '';
    }

    return '';
  }

  function pickVariant(product, candidate) {
    var variants = product?.variants || [];

    if (candidate?.variantId) {
      var match = variants.find(function (variant) {
        return String(variant.id) === String(candidate.variantId);
      });

      if (match) return match;
    }

    for (var i = 0; i < variants.length; i++) {
      if (Number(variants[i].price) > 0) return variants[i];
    }

    return null;
  }

  function showSkeleton(listEl) {
    listEl.innerHTML =
      '<div class="cd-sk-card">' +
        '<div class="cd-sk cd-sk-img"></div>' +
        '<div>' +
          '<div class="cd-sk cd-sk-line"></div>' +
          '<div class="cd-sk cd-sk-line cd-sk-s"></div>' +
        '</div>' +
      '</div>';
  }

  function normalizeMoneyCents(value, fallback) {
    var raw = value;
    var n = Number(raw);

    if (!isFinite(n) || n <= 0) {
      n = Number(fallback || 0);
      raw = fallback;
    }

    if (!isFinite(n) || n <= 0) return 0;

    var rawText = String(raw || '');

    if (rawText.indexOf('.') > -1 || rawText.indexOf(',') > -1) {
      return Math.round(n * 100);
    }

    return Math.round(n);
  }

  function renderCard(listEl, candidate, product) {
    var variant = pickVariant(product, candidate);

    var variantId = candidate?.variantId || variant?.id || '';
    if (!variantId) return false;

    var title = candidate?.title || product?.title || 'Recommended Product';
    var handle = candidate?.handle || product?.handle || '';
    var url = candidate?.url || (handle ? '/products/' + handle : '#');
    var image = candidate?.image || getProductImage(product);
    var img = image ? String(image).replace(/(\.\w+)(\?|$)/, '_120x120_crop_center$1$2') : '';

    var price = normalizeMoneyCents(variant?.price || 0, candidate?.price || 0);
    var cmpAt = normalizeMoneyCents(variant?.compare_at_price || 0, candidate?.compareAtPrice || 0);
    var cmpHtml = cmpAt > price
      ? '<s style="font-size:11px;color:var(--cdmuted);margin-left:3px">' + money(cmpAt) + '</s>'
      : '';

    listEl.innerHTML = '';

    var card = document.createElement('div');
    card.className = 'cd-up-card';
    card.innerHTML =
      '<a href="' + esc(url) + '" class="cd-up-img" tabindex="-1">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(title) + '" width="58" height="58" loading="lazy">' : '') +
      '</a>' +
      '<div class="cd-up-info">' +
        '<a href="' + esc(url) + '" class="cd-up-name">' + esc(title) + '</a>' +
        '<div class="cd-up-price" data-upsell-price="true" data-currency-code="' + esc(getActiveCurrency()) + '">' + money(price) + cmpHtml + '</div>' +
      '</div>' +
      '<button type="button" class="cd-up-add" data-upsell-add data-up-add data-variant="' +
        esc(String(variantId)) + '" aria-label="Add ' + esc(title) + '">Add</button>';

    listEl.appendChild(card);

    return true;
  }

  async function fetchCart() {
    return (await fetch('/cart.js', { headers: _H })).json();
  }

  async function addToCart(variantId) {
    return (await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: String(variantId), quantity: 1 })
    })).json();
  }

  function candidateKey(candidate) {
    if (!candidate) return '';
    return [
      candidate.productId || '',
      candidate.variantId || '',
      candidate.handle || '',
      candidate.title || ''
    ].join(':');
  }

  async function refresh(cart) {
    var wrap = document.getElementById('cd-upsell');
    var listEl = document.getElementById('cd-upsell-list');

    if (!wrap || !listEl) return;

    var candidates = await resolveUpsellCandidates(cart);
    var candidate = pickEligibleCandidate(candidates, cart);

    if (!candidate) {
      wrap.style.display = 'none';
      _renderedKey = null;
      return;
    }

    var key = candidateKey(candidate);

    if (_renderedKey === key) {
      wrap.style.display = '';
      return;
    }

    wrap.style.display = '';
    showSkeleton(listEl);

    var product = await fetchCandidateProduct(candidate);

    if (!product && !candidate.variantId) {
      wrap.style.display = 'none';
      _renderedKey = null;
      return;
    }

    var ok = renderCard(listEl, candidate, product);

    if (ok) {
      _renderedKey = key;
      wrap.style.display = '';
    } else {
      wrap.style.display = 'none';
      _renderedKey = null;
    }
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-upsell-add], [data-up-add]');
    if (!btn) return;

    var listEl = document.getElementById('cd-upsell-list');
    if (!listEl || !listEl.contains(btn)) return;

    var variantId = btn.dataset.variant;
    if (!variantId) return;

    e.preventDefault();
    e.stopPropagation();

    btn.disabled = true;
    btn.textContent = '…';

    try {
      var result = await addToCart(variantId);

      if (result.status) {
        btn.disabled = false;
        btn.textContent = 'Add';
        return;
      }

      btn.classList.add('done');
      btn.textContent = '✓';
      _renderedKey = null;

      var freshCart = await fetchCart();

      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        window.CartDrawer.refresh(freshCart);
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: freshCart }
        }));
      }
    } catch (_) {
      btn.disabled = false;
      btn.textContent = 'Add';
    }
  });

  window.CDUpsell = {
    refresh: refresh,
    reset: function () {
      _renderedKey = null;
    },
    registerRule: function (rule) {
      var registered = registerRule(rule);
      if (registered) fetchCart().then(refresh);
    },
    registerRules: function (rules) {
      (rules || []).forEach(registerRule);
      fetchCart().then(refresh);
    }
  };

  readInitialMetafieldRules();

  if (window._pendingDrawerUpsellRule) {
    registerRule(window._pendingDrawerUpsellRule);
    window._pendingDrawerUpsellRule = null;
  }

  if (Array.isArray(window._pendingDrawerUpsellRules)) {
    window._pendingDrawerUpsellRules.forEach(registerRule);
    window._pendingDrawerUpsellRules = [];
  }

  fetchCart().then(refresh);

})();